import { useTranslation } from 'react-i18next';

export default function WhatToBring() {
  const { t } = useTranslation();
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('seminar.bring.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('seminar.bring.title')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* What to Bring */}
          <div className="border border-background-200/60 bg-background-100/50 p-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center">
                <i className="ri-briefcase-line text-accent-600 text-lg"></i>
              </span>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em]">
                {t('seminar.bring.items.title')}
              </h3>
            </div>
            {String(t('seminar.bring.items.main')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">{__s}</p>))}
            {String(t('seminar.bring.items.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 leading-relaxed tracking-[0.03em] mt-3">{__s}</p>))}
          </div>

          {/* Dress Code */}
          <div className="border border-background-200/60 bg-background-100/50 p-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center">
                <i className="ri-shirt-line text-accent-600 text-lg"></i>
              </span>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em]">
                {t('seminar.bring.attire.title')}
              </h3>
            </div>
            {String(t('seminar.bring.attire.main')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">{__s}</p>))}
            {String(t('seminar.bring.attire.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 leading-relaxed tracking-[0.03em] mt-3">{__s}</p>))}
          </div>
        </div>
      </div>
    </section>
  );
}
